import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { reactive, watch } from "vue";
export default {
  props: ["questionInfo", "allAnswers"],
  setup(props, content) {
    //答案
    let answer = reactive({});
    watch(props, () => {
      let list = {};
      props.questionInfo.questionGroupList.forEach(questionGroup => {
        questionGroup.questionList.forEach(questionItem => {
          list[questionItem.questionId] = props.allAnswers && props.allAnswers[questionItem.questionId] ? props.allAnswers[questionItem.questionId] : "";
        });
      });
      Object.assign(answer, list);
    }, {
      immediate: true
    });
    //更换题目
    watch(() => props.questionInfo, () => {
      document.getElementsByClassName("question")[0].scrollTop = 0;
    });
    function setAnswer() {
      content.emit("setAnswer", answer);
    }
    function clearText(text) {
      while (text.indexOf(">") != -1) {
        text = text.slice(0, text.indexOf("<")) + text.slice(text.indexOf(">") + 1);
      }
      return text.replace(/&nbsp;/g, "");
    }
    return {
      answer,
      setAnswer,
      clearText
    };
  }
};